import styles from "../../BorrowerDetails.module.css";
import CloseIcon from "@mui/icons-material/Close";
import Pdf from "../../../../../assets/PDF_file_icon 4.svg";
import excelIcon from "../../../../../assets/icons8-excel.svg";
import { useState, useEffect } from "react";
import PDFViewer from "../PDFViewer/PDFViewer";
import KeyIcon from "@mui/icons-material/Key";
import { useBorrowerContext } from "../../store/borrower-details";
import EnlargeDocModal from "./EnlargeDocModal";
import { toast } from "react-toastify";
import { useParams } from "react-router";

const MultiDocsModal = ({ title, array, closeModal, isDownload, isDelete, docName }) => {
  const { borrowerData, contextMenuHandler } = useBorrowerContext();
  const borrower = borrowerData.borrower;
  const { loanid } = useParams();
  const fetchedLoanDetails = borrowerData.loan;
  const foundLoan = fetchedLoanDetails.find((item) => item.loan_id === loanid);
  const [pdfModal, setPdfModal] = useState({
    open: false,
    data: "",
  });
  //eslint-disable-next-line
  const [deleteButton, setDeleteButton] = useState(false);

  const [passwordProtected, setPasswordProtected] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [enlargeImage, setEnlargeImage] = useState(false);
  const [imageData, setImageData] = useState({});

  console.log(isDownload, isDelete);
  const viewPdfHandler = (url) => {
    setPdfModal((prevState) => ({
      ...prevState,
      open: true,
      data: `data:application/pdf;base64,${url}`,
    }));
  };

  const enlargeImageModal = (data) => {
    setEnlargeImage(true);
    setImageData(data);
  };

  const closeEnlargeImageModal = () => {
    setEnlargeImage(false);
  };

  const closePdfViewer = () => {
    setPdfModal((prevState) => ({
      ...prevState,
      open: false,
      data: "",
    }));
  };
  useEffect(() => {
    const loadComponentHandler = () => {
      if (title) {
        switch (title) {
          case "Bank Statement":
            setPasswordProtected(true);
            break;
          default:
            if (typeof title === "string" && title?.includes("CPV")) {
              setDeleteButton(true);
            } else {
              setDeleteButton(false);
            }
            break;
        }
      }
    };
    loadComponentHandler();
  }, [title]);

  const showPasswordHandler = () => {
    setShowPassword(!showPassword);
  };

  const excelHandler = () => {
    toast.error("Cannot view excel in your browser. Please download the file");
  };

  return (
    <>
      {/* <ToastContainer /> */}
      {pdfModal.open && (
        <PDFViewer url={pdfModal.data} closeModal={closePdfViewer} />
      )}

      {enlargeImage && (
        <EnlargeDocModal
          doc={imageData.doc}
          docType={imageData.docType}
          closeModal={closeEnlargeImageModal}
          borrowerDetails={borrower}
          loanDetails={foundLoan}
          docName={docName}
        />
      )}

      <div className={styles.borrowerDocumentsModal}>
        <div
          className={styles.borrowerDocumentsModaOverlay}
          onClick={(e) => e.target === e.currentTarget && closeModal()}
        >
          <div
            className={styles.borrowerDocumentsModalContent}
            // onContextMenu={contextMenuHandler}
          >
            <h3>{title}</h3>
            {passwordProtected && (
              <h3
                style={{ marginTop: "-3vh", cursor: "pointer" }}
                onClick={showPasswordHandler}
              >
                <KeyIcon />
                <br />
              </h3>
            )}
            {passwordProtected && showPassword ? (
              <h3 style={{ marginTop: "-3vh" }}>
                {borrower.borrower_bank_statement_password}
              </h3>
            ) : (
              ""
            )}
            <div className={styles.multiDoc}>
              {array.map((data, index) => {
                return data?.docType !== "pdf" ? (
                  <div key={index}>
                    <section>
                      {data.docType !== "xlsx" ? (
                        <img
                          onContextMenu={contextMenuHandler}
                          key={index}
                          draggable={false}
                          src={`data:image/${data.docType};base64,${data.doc}`}
                          alt=""
                          className={styles.docsImg}
                          onClick={() => enlargeImageModal(data)}
                        />
                      ) : (
                        <img
                          src={excelIcon}
                          alt=""
                          className={styles.docsPDF}
                          onClick={excelHandler}
                        />
                      )}
                    </section>
                    <div>
                      <button onClick={data.download}>Download</button>
                    </div>
                    <div>
                      {foundLoan?.loan_status !== "DISBURSED" && (
                        <button
                          style={{ backgroundColor: "red", marginTop: "1vh" }}
                          onClick={data.delete}
                        >
                          Delete
                        </button>
                      )}
                    </div>
                  </div>
                ) : (
                  <div key={index}>
                    <section>
                      <img
                        src={Pdf}
                        alt=""
                        className={styles.docsPDF}
                        onClick={() => viewPdfHandler(data.doc)}
                      />
                    </section>
                    <div>
                      {isDownload && (
                        <button onClick={data.download}>Download</button>
                      )}
                    </div>
                    <div>
                      {foundLoan?.loan_status !== "DISBURSED" && isDelete && (
                        <button
                          style={{ backgroundColor: "red", marginTop: "1vh" }}
                          onClick={data.delete}
                        >
                          Delete
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            <CloseIcon className={styles.CloseIcon} onClick={closeModal} />
          </div>
        </div>
      </div>
    </>
  );
};

export default MultiDocsModal;
